import React, { useState } from "react";
import styled from "styled-components";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldGrid,
    Field,
    FieldInput,
    Req,
    SInput,
} from "../index";
import { Controller, useFormContext } from "react-hook-form";

export default function BlockBancaire() {
    const [iban, setIban] = useState("");

    const digits = iban.replace(/[\s]/g, "");
    const ibanValid = digits.length === 19;
    const ibanInvalid = digits.length > 0 && digits.length < 19;

    const { control } = useFormContext();

    return (
        <BlockCollab>
            <BlockTitleCollab>
                Coordonnées bancaires{" "}
                <BadgeCollab>À compléter par vous</BadgeCollab>
            </BlockTitleCollab>

            <FieldGrid>
                <Field>
                    <label>
                        Nom de la banque <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    onChange={(_, i) => onChange(i.value)}
                                    placeholder={
                                        "Ex : UBS, PostFinance, Raiffeisen..."
                                    }
                                />
                            );
                        }}
                        name="bank_account.bank_name"
                    />
                </Field>
                <Field>
                    <label>
                        N° IBAN suisse <Req>*</Req>
                    </label>
                    <IbanWrapper>
                        <Controller
                            control={control}
                            render={({ field: { onChange, name, ref } }) => {
                                return (
                                    <SInput
                                        fluid
                                        ref={ref}
                                        name={name}
                                        onChange={(_, i) => onChange(i.value)}
                                        placeholder={
                                            "CH56 0483 5012 3456 7800 9"
                                        }
                                        maxLength={22}
                                    />
                                );
                            }}
                            name="bank_account.iban"
                        />
                    </IbanWrapper>
                </Field>
            </FieldGrid>
        </BlockCollab>
    );
}

const IbanWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

const IbanPrefix = styled.span`
    font-size: 13px;
    font-weight: 700;
    color: var(--text-sec);
    flex-shrink: 0;
`;

const IbanInput = styled.input`
    flex: 1;
    height: 36px;
    background: var(--bg-secondary);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0 11px;
    font-size: 13px;
    font-family: monospace;
    letter-spacing: 0.05em;
    color: var(--text-tert);
    outline: none;
    transition: border-color 0.12s;

    &:focus {
        border-color: var(--purple);
        background: white;
        color: var(--text);
    }
`;

const IbanHint = styled.div`
    font-size: 10px;
    margin-top: 3px;
    color: ${({ $valid, $invalid }) =>
        $valid
            ? "var(--green-dark)"
            : $invalid
            ? "var(--red)"
            : "var(--text-tert)"};
`;
